import {
    FormSelect,
    FormInput,
    Heading,
    Loader,
    FormFileInput
} from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
    AUDIENCE,
    LICENSE_CATEGORY,
    DOCUMENT,
    audienceOptions,
} from "./consts";
import { Button } from "@/components/ui";

const AddEdit = () => {
    const {
        breadcrumbData,
        onBackClick,
        form,
        onSubmit,
        requiredFields,
        isAddPending,
        onCancel,
        attachmentRef,
        keys,
        isUpdatePending,
        isView,
        isLoadingHelpDocData,
        onPreviewAttachment,
        isRefetchingAttachment,
        id
    } = useAddEdit();

    const { errors } = form.formState;
    
    return (
        <div className="p-4 md:p-6">
            <Heading
                title={breadcrumbData[breadcrumbData.length - 1].name}
                showBack
                breadcrumbData={breadcrumbData}
                onBackClick={onBackClick}
            />

            {isLoadingHelpDocData ? <Loader /> : <FormProvider {...form}>
                <form
                    onSubmit={form.handleSubmit(onSubmit)}
                    className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]"
                >
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
                        <FormSelect
                            key={keys.audience}
                            name={AUDIENCE}
                            control={form.control}
                            label="Audience"
                            placeholder="Please select"
                            error={errors[AUDIENCE]?.message}
                            isRequired={requiredFields.includes(AUDIENCE)}
                            options={audienceOptions}
                            disabled={isView}
                        />
                        <FormInput
                            name={LICENSE_CATEGORY}
                            control={form.control}
                            label="License Category"
                            placeholder="Please enter"
                            error={errors[LICENSE_CATEGORY]?.message}
                            isRequired={requiredFields.includes(
                                LICENSE_CATEGORY
                            )}
                            disabled={isView}
                        />
                        <div>
                            <FormFileInput
                                fileInputRef={attachmentRef}
                                name={DOCUMENT}
                                control={form.control}
                                label="Doc Upload"
                                accept=".pdf"
                                maxSize={10}
                                isRequired
                                error={errors?.[DOCUMENT]?.message}
                                disabled={isView}
                            />
                            {
                                id && form.watch(DOCUMENT) ? <div><Button type="button" variant="link" onClick={onPreviewAttachment} disabled={isRefetchingAttachment}>View Attachment</Button></div> : <></>
                            }
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 mt-6">
                        <Button
                            variant="outline"
                            type="button"
                            onClick={onCancel}
                            disabled={isAddPending || isUpdatePending}
                        >
                            Cancel
                        </Button>

                        {isView ? <></> : <Button disabled={isAddPending || isUpdatePending}>
                            {isAddPending || isUpdatePending ? <Loader variant="secondary" /> : <></>}
                            Submit
                        </Button>}
                    </div>
                </form>
            </FormProvider>}
        </div>
    );
};

export default AddEdit;
